import React, { useState } from "react";
import axios from "axios";
import "../../styles/Contact.css";
import imageSrc from "../../assets/contact.jpg";
import Footer from "../../layouts/Footer";
import Navbar from "../../layouts/Navbar";
import { ToastContainer, toast } from "react-toastify";
import { EMAIL_REGEX } from "../../constants/common";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNo: "",
    email: "",
    companyName: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeEmail = (e) => {
    setIsValid(EMAIL_REGEX.test(e.target.value));
    setFormData({ ...formData, email: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simple client-side validation
    const errors = {};
    if (!formData.name) errors.name = "Full name is required";
    else if (!/^[A-Za-z\s]+$/.test(formData.name))
      errors.name = "Full name can only contain alphabets and spaces";
    if (!formData.email) errors.email = "Email is required";
    else if (!EMAIL_REGEX.test(formData.email))
      errors.email = "Invalid email format";
    if (!formData.phoneNo) errors.phoneNo = "Phone number is required";
    else if (!/^\d{8,15}$/.test(formData.phoneNo))
      errors.phoneNo = "Phone number must be between 8 and 15 digits";
    if (!formData.companyName) errors.companyName = "Company Name is required";
    if (!formData.message) errors.message = "Message is required";
    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      try {
        const response = await axios.post(
          "https://yelospace.com/api/contact-us",
          formData
        );
        //console.logresponse.data); // Handle response as needed
        toast.success("Submitted Successfully");
        // Optionally reset form after successful submission
        setFormData({
          name: "",
          phoneNo: "",
          email: "",
          companyName: "",
          message: "",
        });
      } catch (error) {
        console.error("Submission error:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false); // Set loading to false if there are validation errors
    }
  };

  return (
    <>
      <Navbar />
      <ToastContainer />
      <div className="custom-contact-us-container">
        <div className="custom-image-container">
          <img
            src={imageSrc}
            alt="About Us"
            className="custom-contact-us-image"
          />
        </div>
        <div className="custom-form-container">
          <div className="d-flex justify-content-left w-100 mt-2 mb-2 ">
            <h2>Contact Us</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="custom-form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Full Name *"
              />
              {errors.name && (
                <span className="custom-error">{errors.name}</span>
              )}
            </div>
            <div className="custom-form-group">
              <input
                type="tel"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleChange}
                placeholder="Phone Number *"
              />
              {errors.phoneNo && (
                <span className="custom-error">{errors.phoneNo}</span>
              )}
            </div>
            <div className="custom-form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChangeEmail}
                placeholder="Email *"
              />
              {!isValid && (
                <span className="custom-error">
                  Please enter a valid email address
                </span>
              )}
              {errors.email && (
                <span className="custom-error">{errors.email}</span>
              )}
            </div>
            <div className="custom-form-group">
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Company Name *"
              />
              {errors.companyName && (
                <span className="custom-error">{errors.companyName}</span>
              )}
            </div>
            <div className="custom-form-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Draft your Message * "
              />
              {errors.message && (
                <span className="custom-error">{errors.message}</span>
              )}
            </div>
            <button
              disabled={loading ? true : false}
              type="submit"
              className="custom-submit-btn"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
